import { Outlet } from 'react-router-dom'
import HelpNav from './HelpNav'

/**
 * Layout for all /help/* routes. Public (no auth). Provides skip link, help nav sidebar, and main content.
 */
export default function HelpLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#help-main" className="skip-link">
        Skip to main content
      </a>
      <div className="flex flex-1">
        <aside
          className="w-56 shrink-0 border-r-2 p-4"
          style={{ borderColor: 'var(--bg-tertiary)' }}
          aria-label="Help sections"
        >
          <HelpNav />
        </aside>
        <main
          id="help-main"
          className="flex-1 container mx-auto px-4 py-8"
          tabIndex={-1}
        >
          <Outlet />
        </main>
      </div>
    </div>
  )
}
